//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Object.js";
import "../no/Preferences.js";
import "../Drawings/Drawings.ViewStyle.js";
let d=[[],[[["feature_name","single_line"],"SetShipDrawingObject",{},2,0],[["feature_name"],"GetShipDrawingObject",{R_:{single_line:''}},1,0],[["feature_name","lines_type","color"],"SetColor",{},3,0],[["feature_name","lines_type"],"GetColor",{R_:{color:"NXColor"}},2,0],[["feature_name","lines_type","font"],"SetFont",{},3,0],[["feature_name","lines_type"],"GetFont",{R_:{font:''}},2,0],[["feature_name","lines_type","width"],"SetWidth",{},3,0],[["feature_name","lines_type"],"GetWidth",{R_:{width:''}},2,0]],[]];
SPLM.Drawings.ShipDraftingViewLinesViewStyle = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.ShipDraftingViewLinesViewStyle";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ShipDraftingViewLinesViewStyle.Lines = Object.freeze({
    "HiddenNonsection" : "HiddenNonsection", "VisibleNonsection" : "VisibleNonsection", "HiddenSection" : "HiddenSection", "VisibleSection" : "VisibleSection", "SecondaryHiddenNonsection" : "SecondaryHiddenNonsection", "SecondaryVisibleNonsection" : "SecondaryVisibleNonsection", "SecondaryHiddenSection" : "SecondaryHiddenSection", "SecondaryVisibleSection" : "SecondaryVisibleSection"});

export default SPLM;